<template>
  <div class="page">
    <div class="media-wrap">
      <barrage
        ref="media"
        v-if="material.materialDetail"
        v-bind="material.materialDetail.config"
      ></barrage>
    </div>
    <div class="opt-wrap">
      <div class="zan" @click="zanShow = true">
        弹幕点赞<van-icon name="arrow" />
      </div>
      <div class="send-wrap">
        <input
          class="send-input"
          placeholder="请输入需要发送的弹幕(最多20个字)"
          type="text"
          v-model="barrageText"
        />
        <div @click="handleBarrageSend" class="btn-send">发送</div>
      </div>
    </div>
    <van-popup v-model="zanShow" position="bottom" :style="{ height: '100%' }">
      <div class="zan-pop-wrap">
        <div class="barrage-zan-list" v-if="barrageList.length > 0">
          <!-- 金句弹幕列表 -->
          <div class="barrage-zan-wrap" v-if="goldBarrage.length > 0">
            <div>
              <div class="barrage-zan-title">金句弹幕</div>
              <div
                class="barrage-zan-item"
                v-for="(item, index) in goldBarrage"
                :key="index"
              >
                <div class="barrage-time" v-text="item.time"></div>
                <div class="barrage-text" v-text="item.content"></div>
                <div class="icon-zan" @click="handleDianZan(item)">
                  <transition name="van-slide-up">
                    <div class="jia" v-show="item.zanShow">+1</div>
                  </transition>
                  <van-icon color="#ff976a" size="24px" name="good-job" />
                </div>
              </div>
            </div>
          </div>
          <!-- 留言弹幕列表 -->
          <div class="barrage-zan-wrap" v-if="selfBarrage.length > 0">
            <div>
              <div class="barrage-zan-title">留言弹幕</div>
              <div
                class="barrage-zan-item"
                v-for="(item, index) in selfBarrage"
                :key="index"
              >
                <div class="barrage-time" v-text="item.time"></div>
                <div class="barrage-text" v-text="item.content"></div>
                <div class="icon-zan" @click="handleDianZan(item)">
                  <transition name="van-slide-up">
                    <div class="jia" v-show="item.zanShow">+1</div>
                  </transition>
                  <van-icon color="#ff976a" size="24px" name="good-job" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="no-data">暂无弹幕</div>
        <div class="btn-zan-close">
          <div @click="zanShow = false" class="btn">关 闭</div>
        </div>
      </div>
    </van-popup>
    <!-- 是否实名发送弹幕弹窗 -->
    <van-dialog
      v-model="realNameShow"
      title="请选择是否实名发送弹幕"
      show-cancel-button
      @confirm="handleRealNameDialogConfirm"
    >
      <div class="realName-dialog-wrap">
        <van-radio-group v-model="isRealName" class="realName-radio">
          <van-radio name="Y">实名发送</van-radio>
          <van-radio name="N">匿名发送</van-radio>
        </van-radio-group>
        <div class="realName-tit">如果选择实名发送，弹幕效果如下：</div>
        <div class="realName-tit">
          {{ userInfo.realname }}：{{ barrageText }}
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { hasLoginCheck } from "@/utils";
import {
  screenMaterialDetailGet,
  screenMaterialBarrageSend,
  screenMaterialBarrageLike,
  screenMaterialBarrageListGet,
} from "@/api/screen";
import { mapGetters } from "vuex";
import {
  STATUS_CODE_OK,
  GET_BARRAGE_LIST_TIME,
  TOAST_STAY_TIME,
} from "@/config";
import Barrage from "@/components/Barrage.vue";
export default {
  name: "Screen",
  data() {
    return {
      id: "", // 排版id字段
      material: {},
      goldBarrage: [], // 金句列表
      selfBarrage: [], // 用户弹幕列表
      barrageList: [], // 总弹幕列表，包括金句
      barrageText: "", // 弹幕内容
      zanShow: false, // 点赞pop弹窗
      realNameShow: false, //匿名弹幕弹窗
      isRealName: "N", //是否匿名弹幕
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.handleMaterialInfoGet();
    this.handleBarrageUpdate();
  },
  methods: {
    // 获取排版信息
    async handleMaterialInfoGet() {
      this.id = this.$route.query.id;
      const { data } = await screenMaterialDetailGet({
        layoutId: this.id,
      });
      if (data.code === STATUS_CODE_OK) {
        data.data.sourceMaterialList.forEach((lItem) => {
          lItem.materialDetail = JSON.parse(lItem.materialDetail);
          // 获取多媒体组件金句弹幕列表
          if (
            lItem.materialDetail.materialId == "8" ||
            lItem.materialDetail.materialId == "11" ||
            lItem.materialDetail.materialId == "12" ||
            lItem.materialDetail.materialId == "13"
          ) {
            this.goldBarrage = lItem.barrageList.map((barrageItem) => {
              return {
                id: barrageItem.id,
                content: barrageItem.barrageDesc,
                time: barrageItem.timeNode,
                zanShow: false,
              };
            });
            this.material = lItem;
          }
        });
        this.handleGetBarrageList();
      }
    },
    // 获取交互弹幕列表
    async handleGetBarrageList() {
      let { data } = await screenMaterialBarrageListGet({
        layoutId: this.id,
      });
      if (data.code === STATUS_CODE_OK) {
        let baList = data.data.map((item) => {
          return {
            id: item.id,
            content: item.barrageDesc,
            time: item.timeNode,
            zanShow: false,
          };
        });
        this.selfBarrage = baList;
        this.barrageList = this.goldBarrage.concat(this.selfBarrage);
        this.material.materialDetail.config = {
          ...this.material.materialDetail.config,
          barrageList: this.barrageList,
        };
      }
    },
    // 获取交互弹幕列表数据更新
    handleBarrageUpdate() {
      this.apiTime = window.setInterval(() => {
        this.handleGetBarrageList();
      }, GET_BARRAGE_LIST_TIME);
    },
    // 弹幕发送
    handleBarrageSend() {
      const that = this;
      that.isRealName = "N";
      hasLoginCheck({
        tip: "请先登录",
        path: that.$route.fullPath,
        callBack: async () => {
          const barrageText = that.barrageText.trim();
          if (!barrageText) {
            that.$notify({
              type: "warning",
              message: "请输入想要发送的弹幕",
              duration: TOAST_STAY_TIME,
            });
            return;
          }
          if (barrageText.length > 20) {
            that.$notify({
              type: "warning",
              message: `请输入的弹幕字数不要超过20个字，当前弹幕字符长度为${barrageText.length}`,
              duration: TOAST_STAY_TIME,
            });
            return;
          }
          that.realNameShow = true;
        },
      });
    },
    // 点赞
    async handleDianZan(item) {
      if (item.zanShow) {
        return;
      }
      item.zanShow = true;
      const { data } = await screenMaterialBarrageLike({
        barrageId: item.id,
      });
      if (data.code === STATUS_CODE_OK) {
        window.setTimeout(() => {
          item.zanShow = false;
        }, 1000);
      }
    },
    // 销毁定时器
    handleTimeDestory() {
      this.apiTime && window.clearInterval(this.apiTime);
    },
    // 实名弹幕弹窗confirm事件
    async handleRealNameDialogConfirm() {
      const timeNode = this.$refs.media.handleBarrageTimeNode();
      const barrageText = this.barrageText.trim();
      const { data } = await screenMaterialBarrageSend({
        layoutMaterialId: this.material.id,
        barrageDesc: barrageText,
        timeNode: timeNode,
        realNameStatus: this.isRealName,
      });
      if (data.code === STATUS_CODE_OK) {
        this.barrageText = "";
        this.$notify({
          type: "success",
          message: "弹幕发送成功",
          duration: TOAST_STAY_TIME,
        });
        this.realNameShow = false;
      }
    },
  },
  beforeDestroy() {
    this.handleTimeDestory();
  },
  components: {
    Barrage,
  },
};
</script>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  .media-wrap {
    width: 100%;
    height: 280px;
  }
  .opt-wrap {
    display: flex;
    align-items: center;
    padding: 10px;
    background-color: #fff;
    border-bottom: 1px solid #eee;
    .zan {
      flex: 0 0 80px;
      text-align: center;
      color: #1989fa;
      cursor: pointer;
    }
    .send-wrap {
      flex: 1;
      display: flex;
      align-items: center;
      .send-input {
        flex: 1;
        border: none;
        background-color: #efefef;
        padding: 6px 12px;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        height: 32px;
      }
      .btn-send {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 60px;
        background-color: #1989fa;
        color: #fff;
        height: 32px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        cursor: pointer;
      }
    }
  }
  .zan-pop-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    .no-data {
      padding: 10px 0;
      text-align: center;
      color: #999;
      font-size: 16px;
    }
    .barrage-zan-list {
      flex: 1;
      overflow-y: auto;
      padding: 8px 0;
      .barrage-zan-wrap {
        margin: 10px 10px 0;
        border: 1px solid #ebeef5;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);

        .barrage-zan-item {
          padding: 8px 10px;
          border-top: 1px solid #eee;
          display: flex;
          align-items: center;
          &:last-child {
            border-bottom: 1px solid #eee;
          }
          .barrage-time {
            flex: 0 0 65px;
            margin-right: 10px;
            text-align: center;
          }
          .barrage-text {
            flex: 1;
          }
          .icon-zan {
            flex: 0 0 30px;
            margin-left: 20px;
            display: flex;
            align-items: center;
            position: relative;
            .jia {
              position: absolute;
              top: -20px;
              left: 5px;
              font-size: 16px;
              color: #ff976a;
            }
          }
        }
        .barrage-zan-title {
          padding: 10px;
          font-size: 16px;
        }
      }
    }
    .btn-zan-close {
      flex: 0 0 60px;
      padding: 10px;
      border-top: 1px solid #eee;
      .btn {
        width: 100%;
        height: 100%;
        color: #fff;
        font-size: 16px;
        background-color: #1989fa;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .realName-dialog-wrap {
    padding: 30px 10px;
    .realName-radio {
      display: flex;
      justify-content: space-around;
    }
    .realName-tit {
      color: #999;
      padding: 10px 10px 0;
      font-size: 14px;
    }
  }
}
</style>
